import React, { Component } from 'react';

import githubLogo from '../img/github.png'
import cpp from '../img/cpp.png'
import python from '../img/python.png'
import processing from '../img/processing.svg'


class ProjectCard extends Component {
  render() {
    return (
        <a  
            href={this.props.github} 
            target="_blank" 
            className={"project-card"}
        >
            <img 
                className={'project-card-icon'}
                alt="github"
                src={githubLogo}
            />


            <div   
                style={styles.titleAndDescription}
            >
                <p className={"project-card-course"}> {this.props.courseName}</p>
                <h2 className={"project-card-title"}>{this.props.title}</h2>
                <div>
                    {this.props.language === "cpp" &&
                    <img 
                        class="language-icon"
                        alt="C++"
                        src={cpp}
                    />
                    }

                    {this.props.language === "python" &&
                    <img 
                        class="language-icon"
                        alt="python"
                        src={python}
                    />
                    }
                    {this.props.language === "processing" &&
                    <img 
                        class="language-icon"
                        alt="proccessing"
                        src={processing}
                    />
                    }
                </div>
                
                {/* <p style={styles.description}>{this.props.description}</p> */}
                {/* <a 
                    target="_blank" 
                    style ={styles.githubButton} 
                    className="btn btn-outline-dark mr-2">
                    <FaGithub/> Source Code
                </a> */}
            </div>
        </a>
    );
  }
}

const styles = {
    card:{
    
    },
    titleAndDescription: {
        width: '100%',
        flex: 1,
        fontSize: '12px',
        justifyContent: 'space-between',
        color: '#000'
    },
    title:{
        
    },
    description:{
    },
    imageWrapper:{
        // width: '50%'
    },
    githubButton:{
        marginTop: '32px',
    }
}
export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/ProjectCard.js